var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","overflow":"auto"}},[_c('h5',[_c('a',{attrs:{"href":'https://cdli.ucla.edu/search/archival_view.php?ObjectID='+_vm.cdli_no,"target":"_blank"}},[_vm._v(_vm._s(_vm.cdli_no))])]),_c('p',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.tablet_content)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-150d8cfc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CDLIView.vue
// module id = null
// module chunks = 